import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import ApiCredentialsPage from './pages/ApiCredentialsPage';
import SubscribedProductsPage from './pages/SubscribedProductsPage';
import TransactionsPage from './pages/TransactionsPage';
import DocumentationPage from './pages/DocumentationPage';
import SettingsPage from './pages/SettingsPage';
import BulkTransferPage from './pages/BulkTransferPage';
import ProductTransactionsPage from './pages/ProductTransactionsPage';
import TeamPage from './pages/TeamPage';
import SystemLogsPage from './pages/SystemLogsPage';
import AcceptInvitePage from './pages/AcceptInvitePage';
import ProfilePage from './pages/ProfilePage';
import PermissionRoute from './components/PermissionRoute';
import { PERMISSIONS } from './utils/permissions';

function App() {
  return (
    <Router>
      <Toaster position="top-right" />

      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/accept-invite" element={<AcceptInvitePage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />

        <Route path="/documentation" element={<DocumentationPage />} />

        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          {/* Public (within layout) */}
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="profile" element={<ProfilePage />} />

          {/* API Keys */}
          <Route element={<PermissionRoute permission={[PERMISSIONS.VIEW_API_KEYS, PERMISSIONS.MANAGE_API_KEYS]} />}>
            <Route path="api-credentials" element={<ApiCredentialsPage />} />
          </Route>

          {/* Products */}
          <Route element={<PermissionRoute permission={[PERMISSIONS.VIEW_PRODUCTS, PERMISSIONS.MANAGE_SUBSCRIPTIONS]} />}>
            <Route path="products" element={<SubscribedProductsPage />} />
          </Route>

          {/* Transactions */}
          <Route element={<PermissionRoute permission={PERMISSIONS.VIEW_TRANSACTIONS} />}>
            <Route path="transactions" element={<TransactionsPage />} />
            <Route path="bulk-transfer" element={<BulkTransferPage />} />
            <Route path="product-transactions/:productId" element={<ProductTransactionsPage />} />
          </Route>

          {/* Settings */}
          <Route element={<PermissionRoute permission={[PERMISSIONS.VIEW_SETTINGS, PERMISSIONS.MANAGE_SETTINGS, PERMISSIONS.MANAGE_WEBHOOKS]} />}>
            <Route path="settings" element={<SettingsPage />} />
            <Route path="system-logs" element={<SystemLogsPage />} />
          </Route>

          {/* Team */}
          <Route element={<PermissionRoute permission={PERMISSIONS.MANAGE_TEAM} />}>
            <Route path="team" element={<TeamPage />} />
          </Route>

          <Route index element={<Navigate to="/dashboard" />} />
        </Route>

        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>

    </Router>
  );
}

export default App;
